import pkg from '../../package.json'

export const APP_VERSION = pkg.version
export const APP_NAME = pkg.name || 'pink-pixel-os'
export const APP_AUTHOR = pkg.author || 'Pink Pixel'
export const APP_HOMEPAGE = pkg.homepage || 'https://pinkpixel.dev'

export default pkg
